import { IDashboardTab } from "../../dashboard/models/table-action.model";

export enum RoleEnum {
    REQUESTER = "REQUESTOR",
    REPORTING_MANAGER = "REPORTING_MANAGER",
    BUYER = "BUYER",
    SUPPLIER = "SUPPLIER",
    ADMIN = "ADMIN",
    QES_APPROVER = "QES_APPROVER",
    PO_BUYER = "PO_BUYER",
    EHS_MANAGER = "EHS_MANAGER",
    FACTORY_PROCUREMENT = "FACTORY_PROCUREMENT"
}

export interface ICustomCellRendererOptions  {
    name : string;
    icon : string
}

export type TypeCellRenderedMethod<T, S> = (t: T, s: S) => Array<ICustomCellRendererOptions>;

export interface IRoleAccessData<T,S> {
    tabList : Array<IDashboardTab>;
    cellRendererOptions : TypeCellRenderedMethod<T,S>;
    allowPRCreation : boolean;
    allowPRDeletion : boolean;
    allowMRPRun : boolean;
}


